































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../types";
import ICountUp from 'vue-countup-v2';
@Component({
    name: "CounterFull",
    components: {
        ICountUp
    }
})

export default class CounterFull extends Vue {
    @Prop() readonly compData!: any;
    delay = 1000;
    showCounter: boolean = false;
    options: any = {
        useEasing: true,
        useGrouping: true,
        separator: '',
        decimal: '.',
        prefix: '',
        suffix: ''
    };
    // prepareData(pos: any): any {
    //     return {
    //         pos: parseInt(pos.endVal)
    //     }
    // }

    handleScroll(event: any) {
        let d: any = document;
        let scrollpos = window.scrollY;
        const elem = d.querySelector('.cnt');
        const counterlist = (window.scrollY + window.innerHeight);
        const isHalfshown = counterlist > elem.offsetTop;
        const countbottom = elem.offsetTop + elem.height;
        const isNotscrolledPast = window.scrollY < countbottom;
        if (isHalfshown) {
            (this as any).showCounter = true;
        }
       
    }

    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
